import React from "react";
import HandIcon from "../../assets/img/svg/hand-icon.svg";
import PhoneIcon from "../../assets/img/svg/phone-icon.svg";
import BrainIcon from "../../assets/img/svg/brain-icon.svg";
import TestIcon from "../../assets/img/svg/test-icon.svg";

const FeatureShowcase = () => {
  const features = [
    {
      icon: "hand",
      title: "Handheld PenEEG™",
      description: "device to record brain electrical activity on-the-go",
      hasGradient: false,
      hasSolidOuterRing: true,
      hasDashedOuterRing: false,
      upperOuterRing: false,
      textColor: "tw-text-blue-400",
    },
    {
      icon: "phone",
      title: "iPhone and iPad application",
      description: "to wirelessly view EEG data anytime, anywhere",
      hasGradient: true,
      gradientColors: "tw-from-green-200 tw-via-teal-100 tw-to-blue-200",
      hasSolidOuterRing: true,
      hasDashedOuterRing: true,
      upperOuterRing: true,
      textColor: "tw-text-gray-800",
    },
    {
      icon: "brain-plus",
      title: "Proprietary machine learning algorithms",
      description: "to detect presence of altered mental status",
      hasGradient: false,
      hasSolidOuterRing: true,
      hasDashedOuterRing: false,
      upperOuterRing: false,
      textColor: "tw-text-blue-400",
    },
    {
      icon: "brain-chart",
      title: "Tests to determine cognitive performance",
      description: "including SCAT-5 and n-Back",
      hasGradient: true,
      gradientColors: "tw-from-teal-200 tw-via-teal-100 tw-to-blue-200",
      hasSolidOuterRing: true,
      hasDashedOuterRing: true,
      upperOuterRing: true,
      textColor: "tw-text-gray-800",
    },
  ];

  return (
    <div className="tw-w-full">
      <div className="tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-gap-6 md:tw-space-x-[-10px]">
        {features.map((feature, index) => (
          <div
            key={index}
            className="tw-relative tw-w-64 tw-h-64 sm:tw-w-64 sm:tw-h-64 tw-flex tw-flex-col tw-items-center tw-justify-center"
          >
            <div
              className={`tw-relative tw-w-full tw-h-full tw-rounded-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center
              ${
                feature.hasGradient
                  ? `tw-bg-gradient-to-br ${feature.gradientColors}`
                  : "tw-bg-white"
              }`}
            >
              {feature.hasSolidOuterRing && (
                <div className="tw-absolute tw-m-1 -tw-top-1 -tw-left-1 -tw-bottom-1 -tw-right-1 tw-rounded-full tw-border tw-border-solid tw-border-blue-300 tw-z-0"></div>
              )}
              {feature.hasDashedOuterRing ? (
                <>
                  <div className="tw-absolute -tw-top-2 -tw-left-2 -tw-right-2 tw-h-1/2 tw-overflow-hidden tw-z-0">
                    <div className="tw-absolute -tw-bottom-full tw-mb-[-20px] tw-inset-0 tw-rounded-full tw-border-4 tw-border-solid tw-border-blue-300"></div>
                  </div>
                  <div className="tw-absolute tw-top-1/2 -tw-left-2 -tw-bottom-2 -tw-right-2 tw-overflow-hidden tw-z-0">
                    <div className="tw-absolute -tw-top-full tw-inset-0 tw-rounded-full tw-border-4 tw-border-dotted tw-border-blue-300 rotate-slow"></div>
                  </div>
                </>
              ) : (
                <div className="tw-absolute tw-top-1/2 -tw-left-2 -tw-bottom-2 -tw-right-2 tw-overflow-hidden tw-z-0">
                  <div className="tw-absolute -tw-top-full tw-inset-0 tw-rounded-full tw-border-4 tw-border-solid tw-border-blue-300"></div>
                </div>
              )}
              <div className="tw-text-4xl tw-mb-4 tw-text-blue-400">
                {feature.icon === "hand" && (
                  <img
                    src={HandIcon}
                    width={48}
                    className="sm:tw-w-12"
                    alt="HandIcon"
                  />
                )}
                {feature.icon === "phone" && (
                  <img
                    src={PhoneIcon}
                    width={48}
                    className="sm:tw-w-12"
                    alt="PhoneIcon"
                  />
                )}
                {feature.icon === "brain-plus" && (
                  <img
                    src={BrainIcon}
                    width={48}
                    className="sm:tw-w-12"
                    alt="BrainIcon"
                  />
                )}
                {feature.icon === "brain-chart" && (
                  <img
                    src={TestIcon}
                    width={48}
                    className="sm:tw-w-12"
                    alt="TestIcon"
                  />
                )}
              </div>
              <h3
                className={`tw-font-medium tw-text-lg tw-mb-2 ${
                  feature.hasGradient ? "tw-text-gray-800" : "tw-text-blue-500"
                }`}
              >
                {feature.title}
              </h3>
              <p
                className={`tw-text-sm ${feature.textColor} tw-max-w-48 tw-mx-auto tw-text-center`}
              >
                {feature.description}
              </p>
            </div>
            {index < features.length - 1 && (
              <div className="tw-absolute tw-top-1/2 tw-right-0 tw-transform tw-translate-x-3 -tw-translate-y-3 tw-z-10">
                <div className="tw-relative tw-w-3 tw-h-3">
                  <div className="tw-absolute tw-inset-0 tw-rounded-full tw-bg-blue-300 tw-opacity-75 tw-animate-ping"></div>
                  <div className="tw-relative tw-w-3 tw-h-3 tw-rounded-full tw-bg-white tw-border-2 tw-border-solid tw-border-blue-300"></div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureShowcase;
